import React from 'react'
import PropTypes from 'prop-types'

import Button from '../../Button/Button'
import CartButton from '../../CartButton/CartButton'
import Dollars from '../../Dollars/Dollars'

import { useNestedModifiers } from '../NestedModifiersProvider/NestedModifiersProvider'
import { useFormik } from '../../FormikProvider/FormikProvider'
import { useAvailability } from '../../../utils/availability'

import { MenuItemDetailsShape } from '../NestedModifiersProvider/Models/MenuItemDetails'
import { ModifierShape } from '../NestedModifiersProvider/Models/Modifier'

export const ModifiersFooter = ({
  getDisplayPrice,
  onClose,
  itemDetails,
  additionalText = ''
}) => {
  const { nestedModifier, nestedModifierIsValid, confirmNestedModifierSelections, modalLoading } = useNestedModifiers()
  const { values, isValid, isSubmitting } = useFormik()
  const { loading: availabilityLoading, orderingAvailable } = useAvailability()

  if (nestedModifier) {
    return (
      <Button
        type='button'
        style='primary'
        disabled={!nestedModifierIsValid}
        onClick={confirmNestedModifierSelections}
        data-testid='nested-modifier-add-button'
      >
        Continue
      </Button>
    )
  }

  if (!orderingAvailable) {
    return (
      <Button
        data-testid='close-modifiers-button'
        style='primary'
        onClick={onClose}
      >
        Close
      </Button>
    )
  }

  if (!values) return null

  const quantity = itemDetails && itemDetails.usesFractionalQuantity ? 1 : values.quantity

  const isLoading = isSubmitting || modalLoading || availabilityLoading || !itemDetails

  let buttonText = quantity ? `Add to Cart (${quantity})` : `Add to Cart`
  buttonText = [buttonText, additionalText].join('')

  return (
    <CartButton
      data-testid='add-to-cart-button'
      type='submit'
      loading={isLoading}
      disabled={!isValid}
      left={buttonText}
      right={<Dollars amount={getDisplayPrice(values)} />}
    />
  )
}

const itemDetailsShape = PropTypes.oneOfType([MenuItemDetailsShape,
  ModifierShape])

ModifiersFooter.propTypes = {
  getDisplayPrice: PropTypes.func,
  onClose: PropTypes.func,
  itemDetails: itemDetailsShape,
  additionalText: PropTypes.string
}
